import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './about.css';
import html from './icons8-html-5-48 (2).png';
import css3 from './icons8-css3-48.png';
import js from './icons8-javascript.gif'
import php from './icons8-php-logo-48.png'
import python from './icons8-python.gif'
import react from './icons8-react.gif'
import node from './icons8-nodejs-48.png'
import mongo from './icons8-mongodb-48.png'
import git from './icons8-github.gif'
import sql from './icons8-sql-server-64.png'
import vs from './icons8-visual-studio-code-2019-48.png'
import jupiter from './icons8-jupyter-48.png'
import fire from './icons8-firebase-48.png'
import boot from './icons8-bootstrap-144.png'
import lime from './icons8-sublime-text-48.png'
import web from './design.svg'
import arti from './intelligence.svg'
const About = () => {
    return (
        <Container>
            <div className="Title">
                <h3>About Me
                    <span> About Me</span>
                </h3>
            </div>
            <div className="about-info">
                <p className="about-text">
                    I have completed four years of academic pursuit in Computer Science and Engineering and graduated with a Bachelor of Science from the BRAC University.
                    During my undergraduate years, I have acquired technical skills in PHP, Python, HTML, Mysql, Javascript.
                    Additionally, my abilities extend to communication and critical thinking. </p>
                <div className="about-details">
                    <div className="left-section">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality</p>
                        <p>Languages</p>
                    </div>
                    <div className="right-section">
                        <p>: Md Sifat Ibn Awlad</p>
                        <p>: 25</p>
                        <p>: Bangladeshi</p>
                        <p>: Bangla(native), English (fluent)</p>
                    </div>
                </div>
            </div>
            <div className="Title mt-5">
                <h3>My Tech Stacks
                    <span> My Skills</span>
                </h3>

            </div>
            <Container className='my-5 categories'>
                <Row className='g-4'>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-dark d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">HTML5</h3>
                            <img src={html} alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-secondary d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">CSS3</h3>
                            <div className="bg-light ">
                                <img src={css3} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-warning d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-dark">JavaScript</h3>
                            <img src={js} alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border orange d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Firebase</h3>
                            <div className="bg-light px-1">
                                <img src={fire} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-primary d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Python</h3>
                            <img src={python} alt="" />
                        </div>
                    </Col>

                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border  purple d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">PHP</h3>
                            <div className="bg-light px-1">
                                <img src={php} alt="" />
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-secondary d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">React</h3>
                            <img src={react} alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-success d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">SQL</h3>
                            <div className="bg-light px-1">
                                <img src={sql} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border  bg-primary d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">VS Code</h3>
                            <div className="bg-light px-1">
                                <img src={vs} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border  bg-warning d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-dark">Node JS</h3>
                            <div className="bg-light px-1">
                                <img src={node} alt="" />
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border  d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Github</h3>
                            <img src={git} alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border orange d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Jupyter</h3>
                            <div className="bg-light px-1">
                                <img src={jupiter} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-success d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">MongoDB</h3>
                            <img src={mongo} alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border boot orange d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Firebase</h3>
                            <div className="bg-light px-1">
                                <img src={boot} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4}  >
                        <div className="p-3 border bg-secondary d-flex align-items-center justify-content-between rounded-3">
                            <h3 className="text-white">Sublime </h3>
                            <div className="bg-light px-1">
                                <img src={lime} alt="" />
                            </div>
                        </div>
                    </Col>
                </Row>

            </Container>

            <div className="Title my-5">
                <h3>Services
                    <span> Services</span>
                </h3>
            </div>
            <Container fluid className='  p-3'>
                <Row className='serve-merge'>
                    <Col xs={12} md={6} className="ServicesSection sec-margin mb-2">
                        <div className="service abt">
                            <div className="service-content">
                                <img src={web} alt="" />
                                <h5 className="s-title">Web design</h5>
                                <p className="s-text">
                                    I love building things from scratch. Hours of work turning into things built block by block was exciting. I was fascinated by the joy of creating. From that point on web development has became my passion.
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} className="ServicesSection">
                        <div className="service abt">
                            <div className="service-content">
                                <img src={arti} alt="" />
                                <h5 className="s-title">Artificial Intelligence</h5>
                                <p className="s-text">
                                    Studying artificial intelligence opens a world of opportunities. During my undergrad I had the opportunity to explore this field. It was a fascinating experience. Even I was able to publish my first research work!!
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default About;

